import styled from 'styled-components';

const ProfileCard = ({name, photo, bio, contact, website}) => {
  const Wrapper = website ? CardWrapper.withComponent('a') : CardWrapper;

  return (
    <Wrapper
      href={website || '#'}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Link to ${name}'s website`}
    >
      <Photo src={photo} alt={`${name}'s photo`} />
      <Content>
        <Name>{name}</Name>
        <Bio>{bio}</Bio>
        <Contact>{contact}</Contact>
      </Content>
    </Wrapper>
  );
};

export type TeamMember = {
  name: string;
  photo: string;
  bio: string;
  contact: string;
  website: string;
};

export const TEAM_MEMBERS: TeamMember[] = [
  {
    name: 'Sierra Wang',
    photo: '/people/sierra-wang.jpeg',
    bio: 'CS PhD Student',
    contact: 'sierraw@stanford.edu',
    website: 'https://sierrawang.github.io/',
  },
  {
    name: 'TJ Jefferson',
    photo: '/people/tj.jpg',
    bio: 'CS MS Student',
    contact: 'tjj@stanford.edu',
    website: 'https://tj401.com/',
  },
];

export const TeamPanel = () => {
  return (
    <ColumnWrapper>
      <Title>TEACHING TEAM</Title>
      {TEAM_MEMBERS.map(m => (
        <ProfileCard key={m.name} {...m} />
      ))}
    </ColumnWrapper>
  );
};

const ColumnWrapper = styled.aside`
  padding: 1rem;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
  color: gray;
`;

const CardWrapper = styled.a`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  gap: 1rem;
  margin-bottom: 1rem;
  text-decoration: none;
  color: inherit;
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    background-color: #f8f8f8;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
`;

const Photo = styled.img`
  width: 100%;
  // height: 80px;
  border-radius: 2px;
  object-fit: cover;
`;

const Content = styled.div`
  flex: 1;
`;

const Name = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
`;

const Bio = styled.p`
  margin: 0.5rem 0;
  font-size: 0.95rem;
  color: #555;
`;

const Contact = styled.div`
  font-size: 0.85rem;
  color: #0077cc;
`;
